import {
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { Transition } from "../../../components/Transition";
import { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import auth from "../../../services/auth";
import { Close } from "@material-ui/icons";
import CohortService from "../../../services/CohortService";
import {
  emailBodyText,
  parseAndValidateEmails,
  surveys,
} from "../../../utils/utils";
import SurveyCard from "./SurveyCard.jsx";
import AlertDialogSlide from "../../../components/deleteModal";
import { ACCOUNT_TYPE } from "../../../utils/constants";

const AssignSurvey = ({
  open,
  handleClose,
  selectedCohort,
  loadDataByCohortIdByPagination,
}) => {
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [participantEmails, setParticipantsEmails] = useState({});
  const [emailsList, setEmailList] = useState({});
  const [selectedFrequencies, setSelectedFrequencies] = useState({});
  const [prevFrequency, setPrevFrequency] = useState({});
  const [emailBody, setEmailBody] = useState({
    [surveys.wellness]: emailBodyText,
    [surveys.jobConfidence]: emailBodyText,
  });
  const [showFrequencyAlertModal, setShowFrequencyAlertModal] = useState({
    [surveys.wellness]: false,
    [surveys.jobConfidence]: false,
  });
  const [emailErrorMessage, setEmailErrorMessage] = useState({
    [surveys.wellness]: "",
    [surveys.jobConfidence]: "",
  });
  const [scheduleDate, setScheduleDate] = useState({});

  const accType = auth.getUserDetails().accType;

  const surveyArray =
    accType === ACCOUNT_TYPE.HIGHER_ED
      ? [surveys.wellness]
      : [surveys.wellness, surveys.jobConfidence];

  const handleEditorChange = (content, editor, survey) => {
    setEmailBody((prev) => ({
      ...prev,
      [survey]: content,
    }));
  };

  const handleCheckboxChange = (surveyKey, value) => {
    const previousValue = selectedFrequencies[surveyKey];

    const isUnchecking = previousValue === value;
    const isSwitching = previousValue !== "no-value" && previousValue !== value;

    // Show popup only if previousValue was a meaningful selection (not 'no-value')
    if (
      prevFrequency[surveyKey] !== "no-value" &&
      prevFrequency[surveyKey] !== undefined &&
      (isUnchecking || isSwitching)
    ) {
      handleSurveyAlert(surveyKey);
    }

    // Update selected value: unchecking sets to 'no-value'
    setSelectedFrequencies((prev) => ({
      ...prev,
      [surveyKey]: isUnchecking ? "no-value" : value,
    }));
  };

  const handleCancel = (survey) => {
    setSelectedFrequencies((prev) => ({
      ...prev,
      [survey]: prevFrequency[survey],
    }));
    handleSurveyAlert(survey);
  };

  const handleSurveyAlert = (survey) => {
    setShowFrequencyAlertModal((prev) => ({
      ...prev,
      [survey]: !prev[survey],
    }));
  };

  const user = auth.getUserDetails();

  const getCohortSurveySchedule = async () => {
    const resss = await CohortService().getCohortSurveySchedule(
      selectedCohort.value
    );
    setScheduleDate(resss?.data);
  };

  useEffect(() => {
    setLoading(true);
    getCohortParticipantsEmail();
    getCohortSurveySchedule();
    setLoading(false);
  }, []);

  const getCohortParticipantsEmail = async () => {
    try {
      const response = await CohortService().getCohortParticipantsEmail(
        selectedCohort.value
      );
      if (response?.data?.data) {
        const emails = {
          [surveys.wellness]: response?.data?.data,
          [surveys.jobConfidence]: response?.data?.data,
        };
        setParticipantsEmails(emails);
        [surveys.wellness, surveys.jobConfidence].forEach((value) => {
          handleEmailsChange(response.data?.data, value);
        });
      }
      const cohortSurvey = await CohortService().getCohortSurvey({
        cohort: selectedCohort.value,
        account: user.accId,
      });
      setSelectedFrequencies(cohortSurvey.data?.data);
      setPrevFrequency(cohortSurvey.data?.data);
    } catch (error) {
      console.error("Error getting paticipant's.", error);
    }
  };

  const handleEmailsChange = (emailsData, survey) => {
    const { validEmails, error } = parseAndValidateEmails(emailsData);

    if (error) {
      setEmailErrorMessage((prev) => ({
        ...prev,
        [survey]: error,
      }));
      return;
    }

    setEmailList((prev) => ({
      ...prev,
      [survey]: validEmails,
    }));
  };

  const localStorage1 = JSON.parse(localStorage.getItem("state"));

  const assignSurvey = async (surveyKey) => {
    setLoading(true);
    const param = {
      name: surveyKey,
      frequency: selectedFrequencies[surveyKey],
      cohort: selectedCohort.value,
      account: user.accId,
      emailsList: Array.from(new Set(emailsList[surveyKey])),
      emailBody: emailBody[surveyKey],
      userId: localStorage1?.user?.userId,
    };

    const assignSurvey = await CohortService().assignSurveyToCohort(param);
    if (assignSurvey.status === 200) {
      setLoading(false);
      handleExpandClick(surveyKey);
      await loadDataByCohortIdByPagination();
      await getCohortSurveySchedule();
      setPrevFrequency((prev) => ({
        ...prev,
        [surveyKey]: selectedFrequencies[surveyKey],
      }));
    }
  };

  const handleExpandClick = (id) => {
    setExpanded((prevState) => ({
      ...prevState,
      [id]: !prevState[id], // Toggle the state for the specific collapse
    }));
  };

  const onEmailChange = (event, survey) => {
    event.preventDefault();
    var emailsData = event.target.value;
    setParticipantsEmails((prev) => ({
      ...prev,
      [survey]: emailsData,
    }));
    setEmailErrorMessage((prev) => ({
      ...prev,
      [survey]: "",
    }));
    handleEmailsChange(emailsData, survey);
  };

  const handleOK = (survey) => {
    handleSurveyAlert(survey);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      maxWidth="md"
      fullWidth
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="sub-heading">Assign Survey</h3>
          <Tooltip title="Close">
            <IconButton onClick={handleClose} aria-label="show more">
              <Close />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent>
        <form className="form-horizontal" noValidate={true}>
          <div className="form-group row ml-1">
            <label className="col-sm-3 form-control-label content-body">
              Cohort Name
            </label>
            <div className="col-sm-9">
              <label className="fw-bold form-control-label form-control-success fields-font">
                <b>{selectedCohort.label}</b>
              </label>
            </div>
          </div>
          {surveyArray.map((survey) => (
            <>
              <SurveyCard
                key={survey}
                surveyKey={survey}
                surveyName={survey}
                emailValue={participantEmails[survey]}
                selectedFrequency={selectedFrequencies[survey]}
                handleFrequencyChange={(val) =>
                  handleCheckboxChange(survey, val)
                }
                assignSurveyHandler={() => assignSurvey(survey)}
                expanded={expanded[survey]}
                handleExpandClick={handleExpandClick}
                emailBody={emailBody[survey]}
                handleEditorChange={handleEditorChange}
                onEmailChange={onEmailChange}
                scheduleDate={scheduleDate[survey] ? scheduleDate[survey] : {}}
                emailErrorMsg={emailErrorMessage[survey]}
                prevFrequency={prevFrequency[survey]}
              />
              <AlertDialogSlide
                show={showFrequencyAlertModal[survey]}
                handleNo={() => handleCancel(survey)}
                handleYes={() => handleOK(survey)}
                title="Survey Frequency Update"
                positiveButtonTitle="Okay"
              >
                {selectedFrequencies[survey] === "no-value" ? (
                  <p className="fields-font">
                    Are you sure you want to stop the survey schedule for{" "}
                    <span className="span">{survey}</span> ? Existing links will
                    be deactivated for this survey and new links will not be
                    generated.
                  </p>
                ) : (
                  <p className="fields-font">
                    Are you sure you want to change the survey frequency for{" "}
                    <span className="span">{survey}</span> to{" "}
                    <span className="span">{selectedFrequencies[survey]}</span>?
                    Existing links will be deactivated, and new links will be
                    generated based on the selected frequency.
                  </p>
                )}
              </AlertDialogSlide>
            </>
          ))}
        </form>
        {loading && <Loader loading={loading} />}
      </DialogContent>
    </Dialog>
  );
};

export default AssignSurvey;
